import { SVGProps } from 'react';

export function ArchonIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Rounded square background — anchor green with subtle white border */}
      <rect width="200" height="200" rx="44" fill="#1A3D2B" stroke="rgba(255,255,255,0.2)" strokeWidth="6" />
      {/* Ball body: pale tint fill */}
      <circle cx="100" cy="80" r="54" fill="#FEF0E8" opacity="0.15" />
      {/* Ball body: white outline */}
      <circle cx="100" cy="80" r="54" stroke="#FFFFFF" strokeWidth="8" fill="none" opacity="0.85" />
      {/* Left seam curve */}
      <path
        d="M 67.6 42.2 Q 92 80 67.6 117.8"
        stroke="#FFFFFF"
        strokeWidth="6.4"
        fill="none"
        opacity="0.5"
        strokeLinecap="round"
      />
      {/* Right seam curve */}
      <path
        d="M 132.4 42.2 Q 108 80 132.4 117.8"
        stroke="#FFFFFF"
        strokeWidth="6.4"
        fill="none"
        opacity="0.5"
        strokeLinecap="round"
      />
      {/* Baseline bar — clay orange */}
      <rect x="30" y="156" width="140" height="11" rx="5.5" fill="#E8621A" />
    </svg>
  );
}
